import {
  checkImageFormat,
  checkVideoFormat,
  isImage,
  isVideo
} from "@/utils/fileFormat";
import * as yup from "yup";

import {
  MAXIMUM_IMAGE_SIZE,
  MAXIMUM_VIDEO_SIZE,
  MAX_DESCRIPTION_CHARACTERS
} from "@/features/push/utils/constants";

export const pushFormValidation = yup.object({
  targets: yup.array().min(1, "mandatory_field_is_empty_error"),
  teaser: yup.mixed().nullable(),
  medias: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required()
      })
    )
    .min(1, "mandatory_field_is_empty_error"),
  caption: yup
    .string()
    .required()
    .max(MAX_DESCRIPTION_CHARACTERS, "push_caption_input_limit_error"),
  price: yup.object({
    value: yup.number().min(0).max(1000)
  }),
  customPrice: yup.object({
    value: yup
      .number()
      .max(1000, "creators_push_price_error")
      .test("customPriceMin", "creators_push_price_error", function (value) {
        if (!value) {
          return true; // Custom price is optional
        }

        return value >= 5;
      })
  }),
  hasDiscount: yup.boolean(),
  discount: yup
    .object({
      price: yup.object({
        value: yup.number()
      }),
      duration: yup.number()
    })
    .nullable()
    .when("hasDiscount", {
      is: true,
      then: () =>
        yup.object({
          price: yup.object({
            value: yup
              .number()
              .moreThan(0, "creators_push_promotion_amount_errorprice_missing")
              .test(
                "lessThanPrice",
                "creators_push_promotion_amount_error",
                function (value, context: any) {
                  if (!value) {
                    return true; // Custom price is optional
                  }

                  return value <= context.options.from[2].value.price.value;
                }
              )
              .required("creators_push_promotion_amount_errorprice_missing")
          }),
          duration: yup
            .number()
            .min(10800, "push_configuration_discount_required_error")
        })
    }),
  scheduledAt: yup.date().nullable(),
  mod: yup.boolean()
});

export const fileValidation = yup
  .mixed()
  .required()
  .test("imageSize", "push_image_file_size_error", (value) => {
    return isImage(value) ? value.size <= MAXIMUM_IMAGE_SIZE : true;
  })
  .test("videoSize", "push_video_file_size_error", (value) => {
    return isVideo(value) ? value.size <= MAXIMUM_VIDEO_SIZE : true;
  })
  .test("imageFormat", "push_invalid_image_format_error", (value) => {
    return isImage(value) ? checkImageFormat(value) : true;
  })
  .test("fileVideoFormat", "push_invalid_video_format_error", (value) => {
    return isVideo(value) ? checkVideoFormat(value) : true;
  })
  .test("fileFormat", "push_invalid_format_error", (value) => {
    return isImage(value) || isVideo(value);
  })
  .required();
